import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IComponentOptions, IController, IModule, IRootScopeService} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {FavorittRessurs} from "felles/tjenester/ressurser/FavorittRessurs";
import {MenyTjeneste} from "web/komponenter/meny/meny";
import IMenu = angular.material.IMenu;

const css = require('./listeFavoritter.scss');

export function registrerListeFavoritterKomponent(angular: IModule) {
    angular
        .component('wmListeFavoritter', listeFavoritterKomponentDef())
}

export function listeFavoritterKomponentDef(): IComponentOptions {
    return {
        bindings: {},
        controller: ListeFavoritterKontroller.forInjisering(),
        template: require('./listeFavoritter.html')
    };
}

export class ListeFavoritterKontroller implements IController {

    static forInjisering() {
        return [
            regNavn.ng.$rootScope,
            regNavn.ng.material.$mdMenu,
            Kontekst.regNavn,
            FavorittRessurs.regNavn,
            MenyTjeneste.regNavn,
            ListeFavoritterKontroller
        ];
    }

    constructor(private $rootScope: IRootScopeService,
                private $mdMenu: angular.material.IMenuService,
                private kontekst: Kontekst,
                private favorittRessurs: FavorittRessurs,
                private menyTjeneste: MenyTjeneste) {
    }

    favoritter: l.FavorittModell[];
    erAapen = false;


    klikk($mdMenu: IMenu, $event) {
        if (this.menyTjeneste.erDeaktivert()) return;
        this.erAapen ?
            this.lukkMeny() :
            this.åpneMeny($mdMenu, $event);
    }

    musInn($mdMenu: IMenu, $event) {
        if (this.menyTjeneste.erDeaktivert()) return;
        this.åpneMeny($mdMenu, $event);
    }

    musUt() {
        this.lukkMeny()
    }


    private åpneMeny($mdMenu: IMenu, $event) {
        this.erAapen = true;
        this.lastFavoritter()
            .then(() => $mdMenu.open($event));
    }

    lukkMeny() {
        this.erAapen = false;
        this.$mdMenu.hide()
    }

    slettet(favoritt: l.FavorittModell) {
        _.remove(this.favoritter, {id: favoritt.id});
    }

    private lastFavoritter() {
        return this.favorittRessurs.brukers().$promise
            .then(favoritter => this.favoritter = favoritter);
    }
}
